import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import textimage from "./../../../../images/foods/textimage.png";
import multmedi from "./../../../../images/foods/multmedi.png";
import textandmulti from "./../../../../images/foods/textandmulti.png";
import texticon from "./../../../../images/foods/texticon.png";
import mediaicon from "./../../../../images/foods/media.png";
import audioalone from "./../../../../images/foods/audioalone.png";
import audiovideo from "./../../../../images/foods/audiovideo.png";
import template from "./../../../../images/foods/template.png";
import imagefile from "./../../../../images/foods/imagefile.png";

const StepOne = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);
  useEffect(() => {
    console.log("props.StepOne", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  return (
    <div className="col-xl-12 col-lg-6">
      <h6 className="card-title">Message Type </h6>

      <div style={{ marginLeft: "150px" }}>
        <form
          onClick={(e) => {
            props.handleChange("selected_message_type", e.target.value);
            // console.log("edfsgdfsg", e.target.value);
          }}
        >
          <ul style={{ display: "flex" }}>
            <li style={{ width: "20%" }}>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="1"
                  checked={
                    props.campaign_creation.selected_message_type == "1"
                      ? true
                      : false
                  }
                />
                <img
                  src={texticon}
                  width="30%"
                  height="60%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}>Text</h6>
              </label>
            </li>

            <li>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="2"
                  checked={
                    props.campaign_creation.selected_message_type == "2"
                      ? true
                      : false
                  }
                  // style={{ marginLeft: "10px" }}
                />
                <img
                  src={imagefile}
                  width="20%"
                  height="50%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}> Image </h6>
              </label>
            </li>

            <li>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="3"
                  checked={
                    props.campaign_creation.selected_message_type == "3"
                      ? true
                      : false
                  }
                  // style={{ marginLeft: "10px" }}
                />
                <img
                  src={audioalone}
                  width="20%"
                  height="50%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}> Audio </h6>
              </label>
            </li>

            <li>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="4"
                  checked={
                    props.campaign_creation.selected_message_type == "4"
                      ? true
                      : false
                  }
                  style={{ marginLeft: "20px" }}
                />
                <img
                  src={mediaicon}
                  width="20%"
                  height="50%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}> Video</h6>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="5"
                  checked={
                    props.campaign_creation.selected_message_type == "5"
                      ? true
                      : false
                  }
                  style={{ marginLeft: "20px" }}
                />
                <img
                  src={audiovideo}
                  width="23%"
                  height="50%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}> Location </h6>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="radio"
                  name="test"
                  value="6"
                  checked={
                    props.campaign_creation.selected_message_type == "6"
                      ? true
                      : false
                  }
                  style={{ marginLeft: "20px" }}
                />
                <img
                  src={template}
                  width="10%"
                  height="50%"
                  style={{ marginLeft: "15px" }}
                />
                <br />
                <h6 style={{ margin: "5px 24px" }}> Template</h6>
              </label>
            </li>
          </ul>
        </form>
      </div>
    </div>
  );
};
export default StepOne;
